var React = require('react');

function Jm (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0l320 240L0 480zm640 0L320 240l320 240z","key":0}),React.createElement("path",{"fill":"#090","d":"M0 0l320 240L640 0zm0 480l320-240 320 240z","key":1}),React.createElement("path",{"fill":"#fc0","d":"M640 0h-59.6L0 435.3V480h59.6L640 44.7z","key":2}),React.createElement("path",{"fill":"#fc0","d":"M0 0v44.7L580.4 480H640v-44.7L59.6 0z","key":3})]));
}

Jm.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Jm;

Jm.default = Jm;
